import { createMachine, assign } from "xstate";

import {
  leadFormMachineContext,
  leadFormMachineEvent,
  leadFormMachineState,
  LeadFormSteps,
  leadFormEvents,
} from "./types";

export const externalEventMachine = createMachine<
  leadFormMachineContext,
  leadFormMachineEvent,
  leadFormMachineState
>({
  id: "externalEventForm",
  initial: LeadFormSteps.eventUserInfo,
  states: {
    [LeadFormSteps.eventUserInfo]: {
      id: LeadFormSteps.eventUserInfo,
      on: {
        [leadFormEvents.submit]: {
          target: LeadFormSteps.createLead,
          actions: ["updateFields"],
        },
      },
    },
    [LeadFormSteps.createLead]: {
      invoke: {
        src: "createLeadMutation",
        onDone: [
          {
            target: LeadFormSteps.eventSuccess,
          },
        ],
        onError: {
          target: LeadFormSteps.eventUserInfo,
          actions: assign({
            errorMessage: (_, event) => {
              return event.data;
            },
          }),
        },
      },
    },
    [LeadFormSteps.eventSuccess]: {
      id: LeadFormSteps.eventSuccess,
      type: "final",
    },
  },

  on: {
    [leadFormEvents.updateContext]: {
      actions: assign((ctx, evt) => ({
        ...ctx,
        ...evt.value,
      })),
      internal: true,
    },
  },
});
